import { getMainSiteUrl } from "../utils/getMainSiteUrl";
import { getSensitiveWord } from "../utils/sensitiveWords";
import "./LinkExpired.css";

export default function LinkExpired() {
  const mainSiteUrl = getMainSiteUrl();

  return (
    <div className="link-expired">
      <div className="link-expired-card">
        <span className="link-expired-icon" aria-hidden="true">
          🔒
        </span>
        <h1 className="link-expired-title">
          {getSensitiveWord("链接已失效")}
        </h1>
        <p className="link-expired-desc">
          {getSensitiveWord("当前访问链接已过期")}
          <br />
          {getSensitiveWord("请重新访问主站获取新链接")}
        </p>
        <a
          className="link-expired-btn"
          href={mainSiteUrl}
          rel="noopener noreferrer"
        >
          {getSensitiveWord("返回主站")}
        </a>
      </div>
    </div>
  );
}
